import { applicationFeesApi, applicationFeesApiV2 } from 'app/services/api';
import _ from 'lodash';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_FEES_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/fees`,
  {
    GET_FEES: 'GET_FEES',
    GET_FEES_SUMMARY: 'GET_FEES_SUMMARY',
    GET_FEES_VIEW: 'GET_FEES_VIEW',
    EDIT_FEES_V3: 'EDIT_FEES_V3',
    GET_FEES_V3: 'GET_FEES_V3',
  },
);

export const getLoanFeesAction = catchAsyncActionError(params => async dispatch => {
  const { data: response } = await applicationFeesApi.getLoanFeesV2(params);

  return dispatch({
    type: LOAN_FEES_ACTION_TYPE.GET_FEES,
    payload: {
      ..._.omit(response, 'metadata'),
      fees: response.loanFees,
    },
  });
});

export const getLoanFeesSummary = params => async dispatch => {
  const { data } = await applicationFeesApiV2.getFeesSummaryByApplicationId(params);

  return dispatch({
    type: LOAN_FEES_ACTION_TYPE.GET_FEES_SUMMARY,
    payload: data,
  });
};

export const getLoanFeesViewAction = params => async dispatch => {
  const { data } = await applicationFeesApiV2.getFeesViewByApplicationId(params);

  return dispatch({
    type: LOAN_FEES_ACTION_TYPE.GET_FEES_VIEW,
    payload: data,
  });
};

export const getRedesignedLoanFeesAction = catchAsyncActionError(params => async dispatch => {
  const { data: response } = await applicationFeesApi.getLoanFeesV3(params);

  return dispatch({
    type: LOAN_FEES_ACTION_TYPE.GET_FEES_V3,
    payload: {
      ..._.omit(response, 'metadata'),
      fees: response.loanFees,
    },
  });
});
